import styles from './PlacingOrderView.module.scss';
import PlacingOrderButtons from '@components/PlacingOrderButtons';
import PlacingOrderHeader from '@components/PlacingOrderHeader';
import PlacingOrderList from './components/PlacingOrderList/PlacingOrderList';
import PlacingOrderNotice from './components/PlacingOrderNotice/PlacingOrderNotice';
import PlacingOrderPoint from './components/PlacingOrderPoint/PlacingOrderPoint';
import PlacingOrderTab from './components/PlacingOrderTab/PlacingOrderTab';
import { Grid } from '@components/Grid';
import { IPlacingOrderPointProps, IPlacingOrderViewProps, TPlacingOrderListItem } from './types';
import { useState } from 'react';

const PlacingOrderView: React.FC<IPlacingOrderViewProps> = (props: IPlacingOrderViewProps): React.ReactElement => {
  const {
    buttons,
    currentStep,
    numberOfSteps,
    parcelsAny,
    parcelsGood,
    placingOrderViewData
  } = props;

  const [selectedTab, setSelectedTab] = useState<number>(1);

  return (
      <Grid>
        <PlacingOrderHeader
            currentStep={currentStep}
            description={placingOrderViewData?.description}
            numberOfSteps={numberOfSteps}
            title={placingOrderViewData?.title}
        />
        <div className={styles.order}>
          {placingOrderViewData?.points && (
              <div className={styles.info}>
                {placingOrderViewData?.points.map((item: IPlacingOrderPointProps, index: number) => (
                    <PlacingOrderPoint
                        key={index}
                        {...item}
                    />
                ))}
              </div>
          )}
          {parcelsAny && placingOrderViewData?.notice && (
              <PlacingOrderNotice title={placingOrderViewData.notice.title}/>
          )}
          <div className={styles.info}>
            {placingOrderViewData?.tabs && (
                <div className={styles.tabs}>
                  {placingOrderViewData?.tabs.map((item, index: number) => (
                      <PlacingOrderTab
                          key={index}
                          handlerOnClick={() => setSelectedTab(index + 1)}
                          selected={selectedTab === index + 1}
                          {...item}
                      />
                  ))}
                </div>
            )}
            {[parcelsGood, parcelsAny].map((item: (TPlacingOrderListItem[] | undefined), index: number) => (
                selectedTab === index + 1 && (
                    <PlacingOrderList
                        key={index}
                        parcels={item!}
                    />
                )
            ))}
          </div>
          {buttons && (
              <PlacingOrderButtons buttons={buttons}/>
          )}
        </div>
      </Grid>
  );
};

export default PlacingOrderView;